import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { IFlowData } from 'src/components/ui/Form/types';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { convertFilterToArray } from 'src/utils/convertFilter';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import {
  changeUserEmailRequest,
  changeUserPasswordRequest,
  confirmUserEmailRequest,
  createUserRequest,
  fetchUserByIdRequest,
  fetchUsersListRequest,
  recoverUserPasswordRequest,
  setUserPasswordRequest,
  updateUserRequest,
} from './requestHandlers';
import { ICreateUser, IUser } from './types';

export const loadUsersStart = createAction('users/load/start');
export const loadUserByIdStart = createAction('users/user/load/start');
export const loadUsersListSuccess = createAction<IUser[]>('users/load/success');
export const loadUserByIdSuccess = createAction<IUser>('users/user/load/success');
export const resetUserById = createAction('users/user/reset');

const defaultParams = {
  page: '0',
  size: '10',
};

export const fetchUsersList = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadUsersStart());
    }
    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });

    mergedParams.roles = convertFilterToArray(mergedParams.roles);
    mergedParams.merchantIds = convertFilterToArray(mergedParams.merchantIds);
    mergedParams.statuses = convertFilterToArray(mergedParams.statuses);

    const data = await fetchUsersListRequest(mergedParams);
    if (data) {
      dispatch(loadUsersListSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};

export const fetchUserById = (id: string) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch(loadUserByIdStart());
    const data = await fetchUserByIdRequest(id);
    if (data) {
      dispatch(loadUserByIdSuccess(data));
    }
  };
};

export const createUser = async (data: ICreateUser): Promise<void> => createUserRequest(data);

export const setUserPassword = async (data: IFlowData): Promise<void> => setUserPasswordRequest(data);

export const recoverUserPassword = async (params: IFlowData): Promise<void> => recoverUserPasswordRequest(params);

export const changeUserEmail = async (data: IFlowData): Promise<void> => changeUserEmailRequest(data);

export const changeUserPassword = async (data: IFlowData): Promise<void> => changeUserPasswordRequest(data);

export const updateUser = async (data: IFlowData): Promise<void> => updateUserRequest(data);

export const confirmUserEmail = async (id: string): Promise<void> => confirmUserEmailRequest(id);
